import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Observable, finalize, takeUntil, tap } from 'rxjs';

import { PageNames } from 'src/app/configs/page-names.enum';

import {
  CustomResultOfPaginatedListOfGetUserValueOfPurchaseStrategiesWithPaginationDto,
  GetEnumValuesDto,
  GetUserValueOfPurchaseStrategiesWithPaginationDto,
} from 'src/app/core/api/models';
import { UserValueOfPurchaseStrategiesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppDomService } from 'src/app/core/services/dom.service';
import {
  BaseIndexModule,
  BaseIndexPageComponent,
} from 'src/app/pages/shared/base';
import { ValueOfPurchaseStrategiesFormComponent } from './value-of-purchase-strategies-form/value-of-purchase-strategies-form.component';

@Component({
  selector: 'app-value-of-purchase-strategies',
  templateUrl: './value-of-purchase-strategies.component.html',
  imports: [BaseIndexModule],
})
export class ValueOfPurchaseStrategiesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.userValueOfPurchaseStrategies;

  modelWithPagination$: Observable<CustomResultOfPaginatedListOfGetUserValueOfPurchaseStrategiesWithPaginationDto>;
  items$: Observable<Array<GetUserValueOfPurchaseStrategiesWithPaginationDto>>;
  paginationApiMethodName =
    this.currentService
      .userValueOfPurchaseStrategiesGetUserValueOfPurchasesWithPagination.name;

  UserValueOfPurchaseIndexEnumValues: GetEnumValuesDto[] = [];
  @Output('closeFormPage') output_closeFormPage = new EventEmitter<boolean>();

  //#endregion

  constructor(protected currentService: UserValueOfPurchaseStrategiesService) {
    super();
  }
  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.showAuditBtn = false;
  }

  getEnumsValues() {
    this.getEnumValuesApi('UserValueOfPurchaseIndex')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (values) => (this.UserValueOfPurchaseIndexEnumValues = values)
      );
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: 'common.title',
        name: 'title',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api
  // Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .userValueOfPurchaseStrategiesDelete({ body: { id: id } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }
  //#endregion

  onCreate(type?: any, isFormModal?: boolean) {
    try {
      const timeout = setTimeout(() => {
        this.pageConfig.isVisibleForm = false;
        clearTimeout(timeout);
      }, 10);
      this.openCreateFormModal();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  openCreateFormModal() {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig?.vocabs}addTitle`,
        isEdit: false,
      };

      const modalResult = this.dialogService.openModal({
        component: ValueOfPurchaseStrategiesFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          finalize(() => (this.pageConfig.isVisibleForm = undefined)),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  onBack() {
    this.output_closeFormPage.emit(true);
  }
  
}
